<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :range-inline="false"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="infraestruturaNome"
                            v-model="model.unidadeId"
                            value-field="id"
                            @change="loadFields('unidade')"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.exames"
                            default-option-text="Todos"
                            label="Exame"
                            show-default-option
                            text-field="exameNome"
                            v-model="model.exameId"
                            value-field="exameId"
                            @change="loadFields('exame')"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.profissionais"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="profissionalNome"
                            v-model="model.profissionalId"
                            value-field="profissionalId"
                            @change="loadFields('profissional')"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.supervisores"
                            default-option-text="Todos"
                            label="Supervisor"
                            show-default-option
                            text-field="supervisorNome"
                            v-model="model.supervisorId"
                            value-field="supervisorId"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="text"
                            v-model="model.status"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            title="Exame(s)"
            type="fieldset"
            v-if="isSearch"
            class="pt-0 pb-0"
        >
            <rkm-row>

                <rkm-col
                    class="flex-grow-1"
                >

                    <rkm-area
                        title="Bloqueado(s)"
                        no-margin-top
                    >

                        <rkm-row>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Quantidade"
                                    v-model="totalizadores.quantidadeBloqueado"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Valor"
                                    v-model="totalizadores.totalBloqueado"
                                    disabled
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col
                    class="flex-grow-1"
                >

                    <rkm-area
                        title="Liberado(s) pelo supervisor"
                        no-margin-top
                    >

                        <rkm-row>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Quantidade"
                                    v-model="totalizadores.quantidadeLiberado"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Valor"
                                    v-model="totalizadores.totalLiberado"
                                    disabled
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col
                    class="flex-grow-1"
                >

                    <rkm-area
                        title="Total"
                        no-margin-top
                    >

                        <rkm-row>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Quantidade"
                                    v-model="totalizadores.quantidadeTotal"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Valor"
                                    v-model="totalizadores.total"
                                    disabled
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="isSearch"
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>


                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="itens"
                no-footer-sorting
                sort-by="data"
            >

                <template v-slot:cell(motivo)="row">
                    <rkm-button
                        color="secondary"
                        small
                        v-rkm-popover.hover.left="{
                            title:'Motivo do bloqueio',
                            html:true,
                            content: row.item.motivo
                        }"
                    >
                        <rkm-icon icon="comment-dots" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

import formatsFilter from '@/filters/formats'
import { mapActions } from 'vuex'
import { repository, error, data, object, stringCase, file } from '@/mixins'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
    },
    created() {

        this.repositories = {
            relatorioExameBloqueado: this.getConectaSusRepository('exameLaboratorial.relatorioExameBloqueado'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            defaultModel: null,
            defaultForm: null,
            model: {
                unidadeId: null,
                exameId: null,
                profissionalId: null,
                supervisorId: null,
                periodo: {
                    start: null,
                    end: null,
                },
                status: null,
            },
            selectedAll: false,
            indeterminate: true,
            selectedCols: [
            ],
            columns: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'nome',
                    label: 'Paciente',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'profissional',
                    label: 'Profissional',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'supervisor',
                    label: 'Supervisor',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'exame',
                    label: 'Exame',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'motivo',
                    label: 'Motivo',
                    class: 'col-min text-center',
                    fixed: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    sortable: true,
                    class: 'col-min text-center',
                    fixed: true
                }
            ],
            itens: [],
            totalizadores: null,
            isSearch: null
        }
    },
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.relatorioExameBloqueado.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model
                    this.defaultModel = this.clone(data.model)
                    this.defaultForm = this.clone(data.form)

                    this.model.periodo.start = moment(data.form.dataAtual, 'DD/MM/YYYY').toDate()
                    this.model.periodo.end = moment(data.form.dataAtual, 'DD/MM/YYYY').toDate()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {

            this.setLoading()

            this.repositories.relatorioExameBloqueado.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data.consulta
                    this.totalizadores = data.totalizadores
                    this.isSearch = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.model = this.clone(this.defaultModel)
            this.form = this.clone(this.defaultForm)
            this.isSearch = false

            this.setDefaultValues()

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioExameBloqueado(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioExameBloqueado(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            })).filter(col => !['motivo'].includes(col.key));

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.columns.map(c => c.key) : []
        },
        loadFields(field) {

            this.setLoading()

            this.setFields(field)

            this.repositories.relatorioExameBloqueado.list(this.prepareData())
                .then(({ data }) => {

                    if (field == 'data') {

                        this.form.unidades = data.form.unidades
                        this.form.exames = data.form.exames
                    } else {

                        this.form.exames = data.form.exames
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setFields(field) {

            this.isSearch = false

            if (field == 'data') {

                this.model.unidadeId = null
                this.model.exameId = null
                this.model.profissionalId = null
                this.model.supervisorId = null
            } else if (field == 'unidade') {

                this.model.exameId = null
                this.model.profissionalId = null
                this.model.supervisorId = null
            } else if (field == 'exame') {

                this.model.profissionalId = null
                this.model.supervisorId = null
            } else {

                this.model.supervisorId = null
            }
        }
    },
    mixins: [repository, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.columns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.columns.length
        },
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.loadFields('data')
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.loadFields('data')
            }
        }
    }
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
</style>